import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { BRAND_PERSON_NAME, BRAND_HANDLE, BRAND_SITE_URL, BRAND_SUPPORT_EMAIL } from '@/lib/brandConfig';
import {
  cloudflareEdgeLanguageDetector,
  persistedUserLanguageDetector,
  querystringLanguageDetector,
  spanishDefaultGeoDetector,
  userExplicitLanguageDetector,
} from './cloudflareDetectors';
import en from './locales/en.json';
import es from './locales/es.json';

// Lazy load para idiomas menos comunes (reduce bundle inicial)
const loadPortuguese = () => import('./locales/pt.json');
const loadGerman = () => import('./locales/de.json');
const loadFrench = () => import('./locales/fr.json');

const languageDetector = new LanguageDetector();
languageDetector.addDetector(querystringLanguageDetector);
languageDetector.addDetector(spanishDefaultGeoDetector);
languageDetector.addDetector(userExplicitLanguageDetector);
languageDetector.addDetector(cloudflareEdgeLanguageDetector);
languageDetector.addDetector(persistedUserLanguageDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en
      },
      es: {
        translation: es
      }
    },
    fallbackLng: 'es',
    supportedLngs: ['en', 'es', 'pt', 'de', 'fr'],
    load: 'languageOnly',
    detection: {
      // Worker cookies (user_language, user_country) + languagePolicy.ts documentan el orden completo.
      order: [
        'querystringLang',
        'spanishDefaultGeo',
        'userExplicitLanguage',
        'cloudflareEdge',
        'persistedUserLanguage',
        'navigator',
        'htmlTag',
        'path',
        'subdomain',
      ],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'user_language',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
      defaultVariables: {
        brandPersonName: BRAND_PERSON_NAME,
        brandFirstName: BRAND_PERSON_NAME.split(" ")[0],
        brandHandle: BRAND_HANDLE,
        brandSiteUrl: BRAND_SITE_URL,
        brandSupportEmail: BRAND_SUPPORT_EMAIL,
      },
    },
    react: {
      useSuspense: false, // Disable suspense to avoid loading delays
    },
  });

// Lazy loading de idiomas adicionales
i18n.on('languageChanged', async (lng) => {
  if (lng.startsWith('pt') && !i18n.hasResourceBundle('pt', 'translation')) {
    const pt = await loadPortuguese();
    i18n.addResourceBundle('pt', 'translation', pt.default);
  } else if (lng.startsWith('de') && !i18n.hasResourceBundle('de', 'translation')) {
    const de = await loadGerman();
    i18n.addResourceBundle('de', 'translation', de.default);
  } else if (lng.startsWith('fr') && !i18n.hasResourceBundle('fr', 'translation')) {
    const fr = await loadFrench();
    i18n.addResourceBundle('fr', 'translation', fr.default);
  }
});

export default i18n;
